import React, { useState } from 'react';

import { checkTenant } from '@libs/NwUtils';

import { useUserPermission } from '@contexts/UserContext';

import { forceReloadFollowup } from '@hooks/API/Event/UseFollowup';

import { EventActionsToolbar } from '@components/EventDrawer/EventDrawerUi/EventUI';
import { NwAddButton } from '@components/Gui/NwButton';
import NwUpload from '@components/Gui/NwUpload';
import AddNonBookingEventTransactionDrawer from '@components/Transactions/TransactionsDrawer/AddNonBookingEventTransactionDrawer';

import { useFollowUpState, useFollowUpDispatch, ACTIONS } from './FollowUpContext';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const FollowUpActions = ({ hasBorder }) => {
    const { plainMode, followUpData, groupType } = useFollowUpState();
    const dispatch = useFollowUpDispatch();
    const [transactionDrawer, setTransactionDrawer] = useState(false);
    const accessAccounting = useUserPermission('AccessAccounting');

    const getUploadEndpoint = () => {
        let endpoint = 'documents/upload/1?';
        if (groupType === 'period') {
            endpoint += `&eventGroupGuid=${followUpData.PeriodGroupGuid}`;
        } else {
            endpoint += `&eventGroupGuid=${followUpData.GroupGuid}`;
        }
        if (followUpData.Project) {
            endpoint = endpoint + `&projectID=${followUpData.Project.ID}`;
        }
        return endpoint;
    };

    const onAfterAddingExpense = () => {
        forceReloadFollowup(followUpData.ID);
        setTransactionDrawer(false);
    };

    const isEliteBooker = checkTenant('elitemodels', true) && !accessAccounting;

    return (
        <>
            <EventActionsToolbar plainMode={plainMode} $hasBorder={hasBorder}>
                {groupType && (
                    <NwUpload
                        size="small"
                        label="add document"
                        maxSize={20}
                        showList={false}
                        types={['all']}
                        onUploadEnd={() => {
                            forceReloadFollowup(followUpData.ID);
                        }}
                        endpoint={getUploadEndpoint()}
                    />
                )}
                {groupType !== 'period' && (
                    <NwAddButton
                        size="small"
                        ghost
                        onClick={() => dispatch({ type: ACTIONS.SET_ADD_MODEL_DRAWER, payload: true })}
                        label="add models"
                    />
                )}
                {groupType !== 'models' && (
                    <NwAddButton
                        size="small"
                        ghost
                        onClick={() => dispatch({ type: ACTIONS.SET_ADD_DATES_DRAWER, payload: true })}
                        label="add dates"
                    />
                )}
                {!followUpData.ProjectID && !isEliteBooker && (
                    <NwAddButton
                        ghost
                        onClick={() => {
                            setTransactionDrawer(true);
                        }}
                        label="add expense"
                        icon={byPrefixAndName.fass['comment-plus']}
                    />
                )}
            </EventActionsToolbar>
            {transactionDrawer && (
                <AddNonBookingEventTransactionDrawer
                    event={followUpData}
                    eventType="followup"
                    onClose={() => setTransactionDrawer(false)}
                    onSave={onAfterAddingExpense}
                    periodGroup={groupType === 'period'}
                />
            )}
        </>
    );
};

export default FollowUpActions;
